module.exports = __webpack_public_path__ + "img/chadle_adv_27.72eaad54.png";